const sortList = [
  {"option": "Best Match"},
  {"option": "Most Popular"},
  {"option": "Status"},
  {"option": "Newest Arrivals"}
];

export default sortList;
